// extracted by mini-css-extract-plugin
module.exports = {"subhead":"home_subhead__DYB9L"};